// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.options-pnl-page .options-pnl-date-filter {
  flex: 0 0 auto;
}

.options-pnl-page .options-pnl-date-filter .so-dateRow {
  flex-wrap: nowrap;
}

.options-pnl-page .options-pnl-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
}

.options-pnl-page .options-pnl-back {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  color: #707a8a;
  cursor: pointer;
  margin-bottom: 8px;
  background: none;
  border: none;
  padding: 0;
}

.options-pnl-page .options-pnl-back:hover {
  color: #f8f8f8;
}

body.light_theme .options-pnl-page .options-pnl-back:hover {
  color: #1e2329;
}

.options-pnl-page .options-pnl-page-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 20px;
  font-weight: 600;
}

.options-pnl-page .options-pnl-visibility-btn {
  border: none;
  background: transparent;
  padding: 2px;
  cursor: pointer;
  color: #707a8a;
  line-height: 1;
}

/* .options-pnl-page .options-pnl-visibility-btn:hover {
  color: #1e2329;
} */

.options-pnl-page .options-pnl-cards {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 16px;
  align-items: stretch;
}

.options-pnl-page .options-pnl-cards .funding-account__summarycard {
  margin: 0;
  height: 100%;
}

.options-pnl-page .options-pnl-metric-card {
  display: flex;
  flex-direction: column;
}

.options-pnl-page .options-pnl-card-k {
  font-size: 14px;
  color: #cfcfcf;
}

body.light_theme .options-pnl-page .options-pnl-card-k {
  color: #707a8a;
}

.options-pnl-page .options-pnl-card-v {
  font-size: 22px;
  font-weight: 600;
  margin-top: 4px;
  text-decoration: none;
}

.options-pnl-page .options-pnl-card-sub {
  font-size: 13px;
  margin-top: 2px;
  text-decoration: none;
}

.options-pnl-page .options-pnl-card-foot {
  min-height: 28px;
  margin-top: 8px;
}

.options-pnl-page .options-pnl-updated {
  font-size: 12px;
  color: #e9e9e9;
}

body.light_theme .options-pnl-page .options-pnl-updated {
  color: #707a8a;
}

.options-pnl-page .options-pnl-pos {
  color: #01bc8d;
}

.options-pnl-page .options-pnl-neg {
  color: #e45561;
}

.options-pnl-page .options-pnl-neutral {
  color: #e9e9e9;
}

body.light_theme .options-pnl-page .options-pnl-neutral {
  color: #707a8a;
}

.options-pnl-page .options-pnl-section-title {
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 4px;
}

body.light_theme .options-pnl-page .options-pnl-section-title {
  color: #1e2329;
}

.options-pnl-page .options-pnl-main-panel.funding-account__summarycard {
  margin-bottom: 0;
}

.options-pnl-page .cmp-tabs-header {
  border-bottom: 1px solid #eaecef29;
}

body.light_theme .options-pnl-page .cmp-tabs-header {
  border-bottom: 1px solid #838383;
}

.alert.alert-danger {
  background: #ffffff0a;
  color: #ffffffb8;
  border-color: #ffffff14;
}

body.light_theme .alert.alert-danger {
  background: #3a3a3aed;
  color: #ffffff;
}

.margin-pro-page .funding-account__header {
  padding-bottom: 10px !important;
}

.options-pnl-page .cmp-tab-btn {
  color: #707a8a;
  padding-bottom: 8px;
  margin-bottom: -1px;
}

body.light_theme .options-pnl-page .cmp-tab-btn {
  color: #707a8a;
}

.options-pnl-page .cmp-tab-btn.active {
  color: #eaecef;

  font-weight: 600;
  border-bottom: 2px solid #1e2329;
}

body.light_theme .options-pnl-page .cmp-tab-btn.active {
  color: #1e2329;
  border-bottom-color: #eaecef;
}

.options-pnl-page .options-pnl-summary-grid {
  border-top: 1px solid #eaecef3d;
  padding-top: 12px;
}

body.light_theme .options-pnl-page .options-pnl-summary-grid {
  border-top: 1px solid #eaecef;
}

.options-pnl-page .options-pnl-charts-row {
  margin-top: 8px;
}

.options-pnl-chart {
  padding: 8px 0 0;
}

.options-pnl-chart__title {
  font-size: 14px;
  font-weight: 600;
  color: #eaecef;
  margin-bottom: 8px;
}

body.light_theme .options-pnl-chart__title {
  color: #1e2329
}

.options-pnl-chart__wrap {
  position: relative;
  width: 100%;
}

.options-pnl-chart__svg {
  width: 100%;
  height: auto;
  display: block;
}

.options-pnl-chart__grid {
  stroke: #eaecef30;
  stroke-width: 1;
}

body.dark_theme .options-pnl-chart__grid {
  stroke: #2b3139;
}

.options-pnl-chart__axis {
  fill: #707a8a;
  font-size: 10px;
}

.options-pnl-chart__zero {
  stroke: #b7bdc6;
  stroke-width: 1;
}

.options-pnl-chart__bar--pos {
  fill: #2ebd85;
}

.options-pnl-chart__bar--neg {
  fill: #f6465d;
}

.options-pnl-chart__bar--cum {
  fill: #f0b90b;
  opacity: 0.85;
}

.options-pnl-chart__line {
  stroke: #f0b90b;
  stroke-width: 2;
}

.options-pnl-chart__dot {
  fill: #f0b90b;
  stroke: #fff;
  stroke-width: 1;
}

.options-pnl-chart__legend {
  display: flex;
  gap: 16px;
  justify-content: center;
  font-size: 12px;
  color: #707a8a;
  margin-top: 8px;
}

.options-pnl-chart__legend span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.options-pnl-chart__legend-bar,
.options-pnl-chart__legend-line {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 2px;
  background: #d1aa67;
}

.options-pnl-chart__legend-line {
  width: 16px;
  height: 0;
  border-top: 2px solid #d1aa67;
  background: none;
  border-radius: 0;
}

.options-pnl-chart__tooltip {
  position: absolute;
  transform: translateX(-50%);
  background: #1e2329;
  color: #fff;
  font-size: 12px;
  padding: 8px 10px;
  border-radius: 4px;
  pointer-events: none;
  white-space: nowrap;
  z-index: 2;
}

.options-pnl-summary-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px 32px;
  margin: 16px 0;
}

.options-pnl-summary-row {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  font-size: 14px;
  padding: 6px 0;
}

.options-pnl-summary-row span:first-child {
  color: #cacaca;
}

body.light_theme .options-pnl-summary-row span:first-child {
  color: #707a8a;
}

.options-pnl-summary-row span:last-child {
  text-decoration: none;
  font-weight: 500;
}

@media (max-width: 991px) {
  .options-pnl-page .options-pnl-cards {
    grid-template-columns: 1fr;
  }

  .options-pnl-summary-grid {
    grid-template-columns: 1fr;
  }
}


@media (max-width: 767px) {

  .options-pnl-page .options-pnl-card-foot {
    min-height: 100%;
  }

}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/OptionsAccountPage/optionsPnlAnalysis.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;;GAEG;;AAEH;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;;EAEd,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,aAAa;AACf;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;;AAGA;;EAEE;IACE,gBAAgB;EAClB;;AAEF","sourcesContent":[".options-pnl-page .options-pnl-date-filter {\n  flex: 0 0 auto;\n}\n\n.options-pnl-page .options-pnl-date-filter .so-dateRow {\n  flex-wrap: nowrap;\n}\n\n.options-pnl-page .options-pnl-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 8px;\n}\n\n.options-pnl-page .options-pnl-back {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 14px;\n  color: #707a8a;\n  cursor: pointer;\n  margin-bottom: 8px;\n  background: none;\n  border: none;\n  padding: 0;\n}\n\n.options-pnl-page .options-pnl-back:hover {\n  color: #f8f8f8;\n}\n\nbody.light_theme .options-pnl-page .options-pnl-back:hover {\n  color: #1e2329;\n}\n\n.options-pnl-page .options-pnl-page-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.options-pnl-page .options-pnl-visibility-btn {\n  border: none;\n  background: transparent;\n  padding: 2px;\n  cursor: pointer;\n  color: #707a8a;\n  line-height: 1;\n}\n\n/* .options-pnl-page .options-pnl-visibility-btn:hover {\n  color: #1e2329;\n} */\n\n.options-pnl-page .options-pnl-cards {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 12px;\n  margin-bottom: 16px;\n  align-items: stretch;\n}\n\n.options-pnl-page .options-pnl-cards .funding-account__summarycard {\n  margin: 0;\n  height: 100%;\n}\n\n.options-pnl-page .options-pnl-metric-card {\n  display: flex;\n  flex-direction: column;\n}\n\n.options-pnl-page .options-pnl-card-k {\n  font-size: 14px;\n  color: #cfcfcf;\n}\n\nbody.light_theme .options-pnl-page .options-pnl-card-k {\n  color: #707a8a;\n}\n\n.options-pnl-page .options-pnl-card-v {\n  font-size: 22px;\n  font-weight: 600;\n  margin-top: 4px;\n  text-decoration: none;\n}\n\n.options-pnl-page .options-pnl-card-sub {\n  font-size: 13px;\n  margin-top: 2px;\n  text-decoration: none;\n}\n\n.options-pnl-page .options-pnl-card-foot {\n  min-height: 28px;\n  margin-top: 8px;\n}\n\n.options-pnl-page .options-pnl-updated {\n  font-size: 12px;\n  color: #e9e9e9;\n}\n\nbody.light_theme .options-pnl-page .options-pnl-updated {\n  color: #707a8a;\n}\n\n.options-pnl-page .options-pnl-pos {\n  color: #01bc8d;\n}\n\n.options-pnl-page .options-pnl-neg {\n  color: #e45561;\n}\n\n.options-pnl-page .options-pnl-neutral {\n  color: #e9e9e9;\n}\n\nbody.light_theme .options-pnl-page .options-pnl-neutral {\n  color: #707a8a;\n}\n\n.options-pnl-page .options-pnl-section-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: #ffffff;\n  margin-bottom: 4px;\n}\n\nbody.light_theme .options-pnl-page .options-pnl-section-title {\n  color: #1e2329;\n}\n\n.options-pnl-page .options-pnl-main-panel.funding-account__summarycard {\n  margin-bottom: 0;\n}\n\n.options-pnl-page .cmp-tabs-header {\n  border-bottom: 1px solid #eaecef29;\n}\n\nbody.light_theme .options-pnl-page .cmp-tabs-header {\n  border-bottom: 1px solid #838383;\n}\n\n.alert.alert-danger {\n  background: #ffffff0a;\n  color: #ffffffb8;\n  border-color: #ffffff14;\n}\n\nbody.light_theme .alert.alert-danger {\n  background: #3a3a3aed;\n  color: #ffffff;\n}\n\n.margin-pro-page .funding-account__header {\n  padding-bottom: 10px !important;\n}\n\n.options-pnl-page .cmp-tab-btn {\n  color: #707a8a;\n  padding-bottom: 8px;\n  margin-bottom: -1px;\n}\n\nbody.light_theme .options-pnl-page .cmp-tab-btn {\n  color: #707a8a;\n}\n\n.options-pnl-page .cmp-tab-btn.active {\n  color: #eaecef;\n\n  font-weight: 600;\n  border-bottom: 2px solid #1e2329;\n}\n\nbody.light_theme .options-pnl-page .cmp-tab-btn.active {\n  color: #1e2329;\n  border-bottom-color: #eaecef;\n}\n\n.options-pnl-page .options-pnl-summary-grid {\n  border-top: 1px solid #eaecef3d;\n  padding-top: 12px;\n}\n\nbody.light_theme .options-pnl-page .options-pnl-summary-grid {\n  border-top: 1px solid #eaecef;\n}\n\n.options-pnl-page .options-pnl-charts-row {\n  margin-top: 8px;\n}\n\n.options-pnl-chart {\n  padding: 8px 0 0;\n}\n\n.options-pnl-chart__title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #eaecef;\n  margin-bottom: 8px;\n}\n\nbody.light_theme .options-pnl-chart__title {\n  color: #1e2329\n}\n\n.options-pnl-chart__wrap {\n  position: relative;\n  width: 100%;\n}\n\n.options-pnl-chart__svg {\n  width: 100%;\n  height: auto;\n  display: block;\n}\n\n.options-pnl-chart__grid {\n  stroke: #eaecef30;\n  stroke-width: 1;\n}\n\nbody.dark_theme .options-pnl-chart__grid {\n  stroke: #2b3139;\n}\n\n.options-pnl-chart__axis {\n  fill: #707a8a;\n  font-size: 10px;\n}\n\n.options-pnl-chart__zero {\n  stroke: #b7bdc6;\n  stroke-width: 1;\n}\n\n.options-pnl-chart__bar--pos {\n  fill: #2ebd85;\n}\n\n.options-pnl-chart__bar--neg {\n  fill: #f6465d;\n}\n\n.options-pnl-chart__bar--cum {\n  fill: #f0b90b;\n  opacity: 0.85;\n}\n\n.options-pnl-chart__line {\n  stroke: #f0b90b;\n  stroke-width: 2;\n}\n\n.options-pnl-chart__dot {\n  fill: #f0b90b;\n  stroke: #fff;\n  stroke-width: 1;\n}\n\n.options-pnl-chart__legend {\n  display: flex;\n  gap: 16px;\n  justify-content: center;\n  font-size: 12px;\n  color: #707a8a;\n  margin-top: 8px;\n}\n\n.options-pnl-chart__legend span {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.options-pnl-chart__legend-bar,\n.options-pnl-chart__legend-line {\n  display: inline-block;\n  width: 12px;\n  height: 12px;\n  border-radius: 2px;\n  background: #d1aa67;\n}\n\n.options-pnl-chart__legend-line {\n  width: 16px;\n  height: 0;\n  border-top: 2px solid #d1aa67;\n  background: none;\n  border-radius: 0;\n}\n\n.options-pnl-chart__tooltip {\n  position: absolute;\n  transform: translateX(-50%);\n  background: #1e2329;\n  color: #fff;\n  font-size: 12px;\n  padding: 8px 10px;\n  border-radius: 4px;\n  pointer-events: none;\n  white-space: nowrap;\n  z-index: 2;\n}\n\n.options-pnl-summary-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px 32px;\n  margin: 16px 0;\n}\n\n.options-pnl-summary-row {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  font-size: 14px;\n  padding: 6px 0;\n}\n\n.options-pnl-summary-row span:first-child {\n  color: #cacaca;\n}\n\nbody.light_theme .options-pnl-summary-row span:first-child {\n  color: #707a8a;\n}\n\n.options-pnl-summary-row span:last-child {\n  text-decoration: none;\n  font-weight: 500;\n}\n\n@media (max-width: 991px) {\n  .options-pnl-page .options-pnl-cards {\n    grid-template-columns: 1fr;\n  }\n\n  .options-pnl-summary-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n\n@media (max-width: 767px) {\n\n  .options-pnl-page .options-pnl-card-foot {\n    min-height: 100%;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
